import { Link } from "react-router-dom";
import { FormActions } from "../../components/common/FormActions";
import {
  createViewEdit,
  formatCurrency,
  formatDate,
  formatDateTime,
  NoWrap,
  numberFormat,
  returnObject,
} from "../../utils/helpers";
import { API_LEDGERS_EXPORT } from "../../utils/apis";

export const useLedgers = () => {
  const tableColumns = () => [
    {
      id: "transaction_date",
      header: "Transaction Date",
      filter: {
        type: "date",
      },
    },
    {
      id: "credit_account_name",
      header: "Credit Account",
      filter: {
        type: "text",
      },
    },
    {
      id: "credit_account_code",
      header: "Credit Account Code",
    },
    {
      id: "debit_account_name",
      header: "Debit Account",
      filter: {
        type: "text",
      },
    },
    {
      id: "debit_account_code",
      header: "Debit Account Code",
    },
    {
      id: "description",
      header: "Description",
    },
    {
      id: "amount",
      header: "Amount",
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      console.log("Item", item);
      const row = {
        ...item,
        created_at: formatDate(item?.created_at),
        amount: formatCurrency(item?.amount),
        transaction_date: <NoWrap>{formatDate(item?.transaction_date)}</NoWrap>,
        description: <NoWrap>{item?.description?.replace(/_/g, " ")}</NoWrap>,
        credit_account_name: (
          <NoWrap>{item?.credit_account_name?.replace(/_/g, " ")}</NoWrap>
        ),
        debit_account_name: (
          <NoWrap>{item?.debit_account_name?.replace(/_/g, " ")}</NoWrap>
        ),
        actions: (
          <FormActions actions={createViewEdit("/ledgers", item?.id, false)} />
        ),
      };
      return row;
    }),
  ];
  const externalFilters = [
    {
      id: "account",
      header: "Account",
      filter: { type: "text" },
    },
  ];

  const tableTotals = (data: any) => {
    return {
      amount: numberFormat(data?.metadata?.total_amount),
    };
  };

  const viewData = (item: any) => {
    return {
      ...returnObject(item?.content_type_model === "loanapplication", {
        loan_application: (
          <Link
            to={`/loan_application/view/${item?.object_id}`}
            className="link-text"
          >
            {item?.object_id}
          </Link>
        ),
      }),
      transaction_ID: item?.transaction_id,
      transaction_type: item?.transaction_type,
      description: item?.description?.replace(/_/g, " "),
      VAT: numberFormat(item?.vat),
      excise_tax: numberFormat(item?.excise_tax),
      amount: formatCurrency(item?.amount),
      payment_type: item?.payment_type,
      payment_date: formatDate(item?.payment_date),
      transaction_code: item?.transaction_code,
      // entry_period: item?.entry_period,
      debit_name: item?.debit_account_name?.replace(/_/g, " "),
      debit_code: item?.debit_account_code,
      credit_name: item?.credit_account_name?.replace(/_/g, " "),
      credit_code: item?.credit_account_code,
      member_account: item?.main_account_name,
      due_date: item?.due_date ? formatDate(item?.due_date) : "",
      next_date: item?.next_date ? formatDate(item?.next_date) : "",
      created_at: formatDateTime(item?.created_at),
      from_account: item?.from_account_name,
      to_account: item?.to_account_name,
      from_wallet: item?.from_wallet_name,
      to_wallet: item?.to_wallet_name,
      transaction_date: formatDate(item?.transaction_date),
    };
  };

  const exportData = {
    api: API_LEDGERS_EXPORT,
    fileName: "ledger_report.xlsx",
  };

  // const activityFilter = "ledger_record";

  return {
    tableColumns,
    tableData,
    viewData,
    tableTotals,
    exportData,
    externalFilters,
    // activityFilter,
  };
};
